import React from 'react';

const ElementsPlaces = [
  {
    d: 'M19.9706 3.02938L18.5535 4.44653C17.0347 3.12767 15.1142 2.25929 13 2.04938V0.0410767C15.6658 0.260998 18.0845 1.35225 19.9706 3.02938Z'
  },
  {
    d: 'M19.9263 5.90215C21.0355 7.34175 21.7612 9.09199 21.9506 11L23.9589 11C23.7561 8.54114 22.8119 6.29248 21.3504 4.47804L19.9263 5.90215Z'
  },
  {
    d: 'M20.9706 19.9706L19.5535 18.5535C20.8723 17.0347 21.7407 15.1142 21.9506 13L23.9589 13C23.739 15.6658 22.6478 18.0844 20.9706 19.9706Z'
  },
  {
    d: 'M18.0979 19.9263C16.6583 21.0354 14.908 21.7612 13 21.9506V23.9589C15.4589 23.7561 17.7075 22.8119 19.522 21.3504L18.0979 19.9263Z'
  },
  {
    d: 'M4.47804 21.3504C6.29248 22.8119 8.54114 23.7561 11 23.9589V21.9506C9.09199 21.7612 7.34175 21.0355 5.90215 19.9263L4.47804 21.3504Z'
  },
  {
    d: 'M2.04938 13L0.0410767 13C0.260997 15.6658 1.35225 18.0845 3.02938 19.9706L4.44653 18.5535C3.12767 17.0347 2.25929 15.1142 2.04938 13Z'
  },
  {
    d: 'M2.64961 4.47802C1.18811 6.29246 0.24393 8.54113 0.0410767 11L2.04938 11C2.23882 9.09199 2.96456 7.34174 4.07373 5.90213L2.64961 4.47802Z'
  },
  {
    d: 'M5.44654 4.44652L4.02938 3.02937C5.91556 1.35224 8.33425 0.260997 11 0.0410767V2.04938C8.88582 2.25929 6.96533 3.12766 5.44654 4.44652Z'
  }
];

const ProgressCircle = (
  props: React.SVGProps<SVGSVGElement> & { progress: number }
): JSX.Element => {
  const { progress, ...restProps } = props;

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}>
      <g>
        {ElementsPlaces.map((pathProps, index) => {
          return (
            <path
              key={pathProps.d}
              {...pathProps}
              fill={index + 1 <= progress ? '#0073F7' : '#c0d6ef'}
            />
          );
        })}
      </g>
    </svg>
  );
};

export default ProgressCircle;
